import errors from "../web/errors";

/**
 * Function to check for the presence of all the config properties that have been deprecated and suggest the new way
 * to use them.
 * @param {Object} config The configuration object used to instantiate the SDK.
 */
export default function configDeprecationWarnings(config) {
  if (config.networkRequestsTimeout) {
    console.warn(errors.authentication.geolocation.NETWORK_REQUESTS_TIMEOUT_CONFIG_DEPRECATED);
  }
}
